export enum HouseholdComparisonTimeframe {
    CURRENT_YEAR = 'CURRENT_YEAR',
    LAST_YEAR = 'LAST_YEAR',
    LAST_MONTH = 'LAST_MONTH',
}

